import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import routes from './routes';
import VTooltip from 'v-tooltip';
import i18n from '@/plugins/i18n';
import Model from "./model";

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VTooltip);

Model.setOnFinishedLoading(() => {
    const router = new VueRouter({
        routes,
        //mode: 'history'
    });

    new Vue({
        i18n,
        router: router,
        render: h => h(App),
        methods: {
            s(str) {
                return str;
            }
        },
        data () {
            return {
                timeout: null
            };
        }
    }).$mount('#app');
});
Model.loadModels();
